export enum AuthenticationErrorType {
  DealroomRecipientEmailNotMatchingLink = 'DealroomRecipientEmailNotMatchingLink',
}
